export enum PatientHandoverType {
  Airport = "airport",
  Hospital = "hospital",
}
